import { MapPin, Mail, MessageCircle } from 'lucide-react';

const Contact = () => {

  return (
    <section id="contact" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-blue-900 mb-4">
            Contact Us
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Our Office - Left Side */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-blue-900 mb-6">
                Our Office
              </h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-blue-900 p-3 rounded-lg">
                    <MapPin className="text-white" size={24} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-900 mb-1">
                      FAL Consultancy Company Limited
                    </h4>
                    <p className="text-gray-600">
                      Room 605, 6/F, Tai Tung Building<br />
                      8 Fleming Road, Wanchai<br />
                      Hong Kong
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-blue-900 p-3 rounded-lg">
                    <Mail className="text-white" size={24} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-900 mb-1">Email</h4>
                    <p className="text-gray-600">fal@falconsultancy.com</p>
                  </div>
                </div>

                {/* WhatsApp Business - Disabled, will be activated later */}
                <div className="flex items-start space-x-4 opacity-50 cursor-not-allowed">
                  <div className="bg-blue-900 p-3 rounded-lg">
                    <MessageCircle className="text-white" size={24} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-900 mb-1">
                      WhatsApp Business
                    </h4>
                    <p className="text-gray-600">
                      Chat with us instantly
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Connect with FAL - Right Side */}
          <div className="flex items-center justify-center">
            {/* Connect with FAL Button */}
            <a 
              href="https://docs.google.com/forms/d/e/1FAIpQLSdO2PL_DwpE3RYjgePGqPxuTWAyleiBb6RUHgo9So7VXFE00g/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <div className="bg-blue-900 hover:bg-blue-800 transition-all duration-200 rounded-xl p-4 shadow-lg hover:shadow-xl transform hover:-translate-y-1 cursor-pointer">
                <div className="flex items-center space-x-2 mb-2">
                  <div className="bg-white p-2 rounded-lg">
                    <Mail className="text-blue-900" size={20} />
                  </div>
                  <h4 className="text-lg font-bold text-white">
                    Connect with FAL
                  </h4>
                </div>
                <p className="text-blue-100 text-xs">
                  Click here to open our contact form and share your inquiry with us.
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;